import { useDispatch } from "react-redux";

import {
  getListData,
  deleteConditionData,
  createConditionData,
  editConditionData,
  getConstantsData,
  getViewConditionData,
  clearDeleteConditionState,
  clearListState,
  clearConstantsState,
  clearCreateConditionState,
  clearEditConditionState,
  clearViewConditionState,
  payloadSubAffDealsV2List,
  getFilterCreatorData,
  getSubAffDealData,
  clearSubAffDealState,
  getSubAffDealLevelsData,
  clearSubAffDealLevelsState,
  getSubAffDealListData,
  clearSubAffDealListState,
  updateSubAffDealData,
  clearUpdateSubAffDealState,
  getHistoryData,
  clearHistoryState,
  deleteHistoryRowData,
  clearDeleteHistoryRowState,
  updateHistoryRowData,
  clearUpdateHistoryRowState,
  getSubAffDealOptionsListData,
  clearSubAffDealOptionsListState,
  updateRefProgramStatusData,
  clearUpdateRefProgramStatusState,
  getParentSubAffDealData,
  createInitialSubAffDealData,
  clearInitialSubAffDealState,
  clearParentSubAffDealState,
} from "./index";


export const useSubAffDealsV2 = () => {
  const dispatch = useDispatch();

  const getList = (data: payloadSubAffDealsV2List) => dispatch(getListData(data));
  const clearList = () => dispatch(clearListState());

  const deleteCondition = (data: any) => dispatch(deleteConditionData(data));
  const clearDeleteCondition = () => dispatch(clearDeleteConditionState());

  const getConstants = () => dispatch(getConstantsData());
  const clearConstants = () => dispatch(clearConstantsState());

  const createCondition = (data: any) => dispatch(createConditionData(data));
  const clearCreateCondition = () => dispatch(clearCreateConditionState());

  const getViewCondition = (id: string) => dispatch(getViewConditionData(id));
  const clearViewCondition = () => dispatch(clearViewConditionState());

  const editCondition = (data: any) => dispatch(editConditionData(data));
  const clearEditCondition = () => dispatch(clearEditConditionState());

	const getFilterCreator = (data: any) => dispatch(getFilterCreatorData(data));

  const getSubAffDeal = (id: string) => dispatch(getSubAffDealData(id));
  const clearSubAffDeal = () => dispatch(clearSubAffDealState());

  const getSubAffDealLevels = (id: string) => dispatch(getSubAffDealLevelsData(id));
  const clearSubAffDealLevels = () => dispatch(clearSubAffDealLevelsState());

  const getSubAffDealList = (data: any) => dispatch(getSubAffDealListData(data));
  const clearSubAffDealList = () => dispatch(clearSubAffDealListState());

  const updateSubAffDeal = (data: any) => dispatch(updateSubAffDealData(data));
  const clearUpdateSubAffDeal = () => dispatch(clearUpdateSubAffDealState());

  const getHistory = (data: any) => dispatch(getHistoryData(data));
  const clearHistory = () => dispatch(clearHistoryState());

  const deleteHistoryRow = (data: any) => dispatch(deleteHistoryRowData(data));
  const clearDeleteHistoryRow = () => dispatch(clearDeleteHistoryRowState());

  const updateHistoryRow = (data: any) => dispatch(updateHistoryRowData(data));
  const clearUpdateHistoryRow = () => dispatch(clearUpdateHistoryRowState());

  const getSubAffDealOptionsList = (data: any) => dispatch(getSubAffDealOptionsListData(data));
  const clearSubAffDealOptionsList = () => dispatch(clearSubAffDealOptionsListState());

  const updateRefProgramStatus = (data: any) => dispatch(updateRefProgramStatusData(data));
  const clearUpdateRefProgramStatus = () => dispatch(clearUpdateRefProgramStatusState());

  const getParentSubAffDeal = (data: any) => dispatch(getParentSubAffDealData(data));
  const clearParentSubAffDeal = () => dispatch(clearParentSubAffDealState());

  const createInitialSubAffDeal = (data: any) => dispatch(createInitialSubAffDealData(data));
  const clearInitialSubAffDeal = () => dispatch(clearInitialSubAffDealState());

  return {
    getList,
    clearList,
    deleteCondition,
    clearDeleteCondition,
    getConstants,
    clearConstants,
    createCondition,
    clearCreateCondition,
    getViewCondition,
    clearViewCondition,
    editCondition,
    clearEditCondition,
	  getFilterCreator,
    getSubAffDeal,
    clearSubAffDeal,
    getSubAffDealLevels,
    clearSubAffDealLevels,
    getSubAffDealList,
    clearSubAffDealList,
    updateSubAffDeal,
    clearUpdateSubAffDeal,
    getHistory,
    clearHistory,
    deleteHistoryRow,
    updateHistoryRow,
    clearDeleteHistoryRow,
    clearUpdateHistoryRow,
    getSubAffDealOptionsList,
    clearSubAffDealOptionsList,
    updateRefProgramStatus,
    clearUpdateRefProgramStatus,
    getParentSubAffDeal,
    createInitialSubAffDeal,
    clearInitialSubAffDeal,
    clearParentSubAffDeal,
  }
}
